<script lang="ts">
  import { DateInput, type Locale } from 'date-picker-svelte';

  type Input =
    | 'text'
    | 'password'
    | 'email'
    | 'tel'
    | 'number'
    | 'textarea'
    | 'file'
    | 'date'
    | 'datetime';
  export let type: Input = 'text';
  export let label: string | undefined = '';
  export let error: string | undefined = undefined;
  export let name: string;
  export let required = false;
  export let width = '100%';
  export let value = '';
  export let theme: 'light' | 'dark' = 'light';
  export let autocomplete: string | undefined = undefined;
  export let disabled = false;
  export let files: FileList | undefined = undefined;
  export let accept = '*';
  export let textarea: HTMLTextAreaElement | undefined = undefined;
  export let min: string | number | undefined = undefined;
  export let max: string | number | undefined = undefined;
  export let step: string | number | undefined = undefined;
  export let onSelect: (() => void) | undefined = undefined;
  function typeAction(node: HTMLInputElement) {
    node.type = type;
  }
  let date = new Date();
  $: if (type === 'date' || type === 'datetime') {
    value = date.toISOString();
  }
  const locale: Locale = {
    months: [
      'Leden',
      'Únor',
      'Březen',
      'Duben',
      'Květen',
      'Červen',
      'Červenec',
      'Srpen',
      'Září',
      'Říjen',
      'Listopad',
      'Prosinec'
    ],
    weekdays: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
    weekStartsOn: 1
  };
</script>

<div class="input input-{theme}" class:input--error={error} style="--input-width: {width}">
  {#if type === 'textarea'}
    <textarea
      bind:this={textarea}
      {name}
      bind:value
      id={name}
      {required}
      placeholder=" "
      {autocomplete}
      {disabled}
      on:select={onSelect}
    />
  {:else if type === 'date' || type === 'datetime'}
    <input type="hidden" {name} bind:value id={name} {required} />
    <DateInput
      bind:value={date}
      {locale}
      format={'dd. MM. yyyy' + (type === 'date' ? '' : ' HH:mm:ss')}
      {disabled}
    />
  {:else if type === 'file'}
    <input
      type="file"
      {name}
      bind:value
      id={name}
      {required}
      placeholder=" "
      {autocomplete}
      {disabled}
      {accept}
      bind:files
    />
  {:else}
    <input
      use:typeAction
      {name}
      bind:value
      id={name}
      {required}
      placeholder=" "
      {autocomplete}
      {disabled}
      {min}
      {max}
      {step}
    />
  {/if}
  {#if label}
    <label for={name}>{label}</label>
  {/if}
  {#if error}
    <p class="input__error">{error}</p>
  {/if}
</div>

<style lang="scss">
  .input {
    position: relative;
    width: var(--input-width);

    label {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 17px;
      font-weight: 500;
      line-height: 22px;
      color: rgba($color-dark-gray, 0.6);
      pointer-events: none;
      transition: 0.3s ease all;
    }

    input,
    textarea {
      height: 37px;
      padding-bottom: 10px;
      width: var(--input-width);
      border: none;
      appearance: none;
      outline: none;
      border-bottom: 1px solid $color-medium-gray;
      font-size: 17px;
      line-height: 22px;
      font-weight: 500;
      color: $color-dark-gray;
      background-color: transparent;
      border-radius: 0;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        appearance: none;
        margin: 0;
      }
      &[type='number'] {
        -moz-appearance: textfield;
        appearance: textfield;
      }

      &:not(:placeholder-shown),
      &:focus {
        border: none;
        border-bottom: 1px solid $color-caramel;

        + label {
          font-size: 12px;
          line-height: 19px;
          translate: 0px -17px;
          color: $color-caramel;
        }
      }
    }

    textarea {
      height: 130px;
      resize: none;
    }

    &-dark {
      label {
        color: $color-white;
      }
      input,
      textarea {
        color: $color-white;
      }
    }
    &__error {
      color: $color-red;
      font-size: 12px;
      line-height: 19px;
      margin-top: 3px;
      display: none;
    }
    &--error {
      .input {
        &__error {
          display: block;
          position: absolute;
          top: calc(100% + 2px);
        }
      }
      input,
      textarea {
        border-bottom: 1px solid $color-red;

        &:not(:placeholder-shown),
        &:focus {
          + label {
            color: $color-red;
          }
        }
      }
    }
  }
</style>
